import { initContract } from '@ts-rest/core';
import { adminAnalyticsContract } from './analytics.admin.contract';

const c = initContract();

export const analyticsContract = c.router(
  {
    admin: adminAnalyticsContract,
  },
  {
    pathPrefix: '/analytics',
    strictStatusCodes: true,
  },
);

export * from './analytics.admin.contract';
export * from './models';

